// extracted by mini-css-extract-plugin
export default {"StatusNew":"StatusNew_StatusNew__JNXoh","active":"StatusNew_active__DAMak","discontinued":"StatusNew_discontinued__yW11s","available":"StatusNew_available__1sISl"};